import { Input } from 'antd';
import { memo, useCallback, useState } from 'react';
import { useWorkflowReadOnly } from '../../../hooks/use-workflow';
interface TitleInputProps {
  value: string;
  onBlur: (value: string) => void;
  disabled?: boolean;
  maxLength?: number;
}

export const TitleInput = memo(
  ({ value, onBlur, disabled }: TitleInputProps) => {
    const [localValue, setLocalValue] = useState(value);

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
      e.stopPropagation();
      e.preventDefault();
      if (!localValue) {
        setLocalValue(value);
        onBlur(value);
        return;
      }

      onBlur(localValue);
    };

    return (
      <input
        maxLength={32}
        disabled={disabled}
        value={localValue}
        onChange={(e) => setLocalValue(e.target.value)}
        className={`
        grow px-1 h-6 text-base text-gray-900 font-semibold rounded-lg border border-transparent appearance-none outline-none
        hover:bg-gray-50
        focus:border-gray-300 focus:shadow-xs focus:bg-white caret-[#295EFF]
        disabled:bg-transparent
      `}
        placeholder={'请输入标题'}
        onBlur={handleBlur}
      />
    );
  },
);
TitleInput.displayName = 'TitleInput';

// type DescriptionInputProps = {
//   value: string;
//   onChange: (value: string) => void;
// };
// export const DescriptionInput = memo(
//   ({ value, onChange }: DescriptionInputProps) => {
//     const [focus, setFocus] = useState(false);
//     const handleFocus = useCallback(() => {
//       setFocus(true);
//     }, []);
//     const handleBlur = useCallback(() => {
//       setFocus(false);
//     }, []);
//
//     return (
//       <div
//         className={`
//         group flex px-2 py-[5px] max-h-[60px] rounded-lg overflow-y-auto
//         border border-transparent hover:bg-gray-50 leading-0
//         ${focus && '!border-gray-300 shadow-xs !bg-gray-50'}
//       `}
//       >
//         <Input.TextArea
//           value={value}
//           onChange={(e) => onChange(e.target.value)}
//           rows={1}
//           onFocus={handleFocus}
//           onBlur={handleBlur}
//           className={`
//           w-full text-xs text-gray-900 leading-[18px] bg-transparent
//           appearance-none outline-none resize-none
//           placeholder:text-gray-400 caret-[#295EFF]
//         `}
//           autoSize
//           placeholder="请输入描述"
//         />
//       </div>
//     );
//   },
// );
// DescriptionInput.displayName = 'DescriptionInput';
